export default "__VITE_ASSET__CGVj9e5$__"